import EComProducts from "./EComProducts";

const MAPPING = {
  ecom_products: <EComProducts />,
};

export default MAPPING;
